import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Nav, NavItem, Tab } from 'react-bootstrap';

import { connect } from 'react-redux';
import { setShowArchivedPlans } from './store/settings/actions';

import AddControl from 'components/add_control';
import CommissionPlanIcon from 'logos/commission-plan.svg';
import EmptyState from 'bundles/settings/empty_state';
import ManagedInput from 'components/form/managed_input';
import PlanModal from './form/modal';
import PlansTable from './table';
import Users from './users';

import './styles.scss';

export function CommissionPlanSettings({ plans, setShowArchivedPlans, showArchivedPlans }) {
  const [activeKey, setActiveKey] = useState('plans');
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="row">
      <div className="col-xs-12 commission-plans-index">
        <h3 className="mt-0">Commission Plans</h3>

        <Tab.Container activeKey={activeKey} id="plans" onSelect={setActiveKey}>
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <Nav bsStyle="pills" className="rounded mb-3">
                <NavItem eventKey="plans">Plans</NavItem>
                <NavItem eventKey="users">Brokers</NavItem>
              </Nav>

              <div className="d-flex align-items-center">
                {!!plans.length && activeKey === 'plans' &&
                  <ManagedInput
                    name="showArchivedPlans"
                    type="checkbox"
                    value={showArchivedPlans}
                    onValueChange={setShowArchivedPlans}
                  >
                    Show Archived Plans
                  </ManagedInput>
                }

                <AddControl className="ml-3" name="add-plan" onClick={() => setShowModal(true)}>
                  Add Commission Plan
                </AddControl>
              </div>
            </div>

            <Tab.Content animation={false}>
              <Tab.Pane eventKey="plans">
                {plans.length ? <PlansTable/> :
                  <EmptyState
                    buttonText="Add Commission Plan"
                    iconClassNames="commission-plans"
                    imageSrc={CommissionPlanIcon}
                    message="No commission plan(s) have been added yet"
                    onClick={() => setShowModal(true)}
                  />
                }
              </Tab.Pane>
              <Tab.Pane eventKey="users">
                <Users/>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>

        <PlanModal
          plan={{ name: '', tiers: [{ brokerSplit: 0 }], users: [], resetPeriod: 1 }}
          show={showModal}
          onClose={() => setShowModal(false)}
        />
      </div>
    </div>
  );
}

CommissionPlanSettings.propTypes = {
  plans: PropTypes.array.isRequired,
  setShowArchivedPlans: PropTypes.func.isRequired,
  showArchivedPlans: PropTypes.bool,
};

const mapStateToProps = state => ({
  plans: state.plans,
  showArchivedPlans: state.settings.showArchivedPlans,
});

const mapDispatchToProps = {
  setShowArchivedPlans,
};

export default connect(mapStateToProps, mapDispatchToProps)(CommissionPlanSettings);
